var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaSettingsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 25.5V4.51633C5.8332 4.07037 5.98119 3.637 6.25408 3.28427C6.52696 2.93155 6.90927 2.67945 7.34097 2.56758C7.77267 2.4557 8.22931 2.49039 8.63916 2.66619C9.049 2.84198 9.38885 3.14894 9.60533 3.53883L21.228 24.4612C21.4445 24.8511 21.7843 25.158 22.1942 25.3338C22.604 25.5096 23.0606 25.5443 23.4923 25.4324C23.924 25.3205 24.3064 25.0685 24.5792 24.7157C24.8521 24.363 25.0001 23.9296 25 23.4837V2.5M2 10.1667H28.8333M2 17.8333H28.8333",
    stroke: "#00332D",
    strokeWidth: 3.68,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaSettingsDark);
export default __webpack_public_path__ + "static/media/nairaSettingsDark.4352e05397efd2e32b69711fa0cf46c8.svg";
export { ForwardRef as ReactComponent };